import type { ApiPaths } from '@reos/api-client';
import { apiClient, baseUrl } from './api.js';
import { unwrap } from './api-error.js';

/**
 * Exporty reportu (krok O5b). Do 6. 9. vedly odkazy na staticke soubory v
 * `public/reporty/` (krok S3 je smazal, cesty zustaly mrtve) — ted je vyrabi
 * API z aktualnich dat auditu v brandu kancelare.
 *
 * HTML nahled se otevira jako ODKAZ do noveho okna (ne fetch): prohlizec
 * dokument rovnou vykresli a session cookie posle sam. PDF se objedna
 * (`POST`), worker ho vyrobi a UI ho pak stahne z `downloadPath`.
 */

/** Zapis MUSI sedet s `REPORT_KINDS` v @reos/reports a s CHECK na `dd_exports.kind`. */
export type ReportExportKind =
  | 'interni-audit'
  | 'prezentace-majiteli'
  | 'technicky-report'
  // Krok REP1 — dokumenty rendereru v5.
  | 'report-podrobny'
  | 'report-klient';

export type DdExport =
  ApiPaths['/v1/duediligence/cases/{id}/exports']['get']['responses']['200']['content']['application/json']['items'][number];

/** Adresa HTML nahledu — patri do `href`/`window.open`, ne do fetch. */
export function reportPreviewUrl(ddCaseId: string, kind: ReportExportKind): string {
  return `${baseUrl}/v1/duediligence/cases/${ddCaseId}/export/${kind}.html`;
}

/** Adresa hotoveho souboru; `downloadPath` je null, dokud export nedobehne. */
export function exportDownloadUrl(item: DdExport): string | null {
  return item.downloadPath === null ? null : `${baseUrl}${item.downloadPath}`;
}

export async function listCaseExports(ddCaseId: string): Promise<readonly DdExport[]> {
  const result = await unwrap(
    apiClient.GET('/v1/duediligence/cases/{id}/exports', { params: { path: { id: ddCaseId } } }),
  );
  return result.items;
}

/** Objedna PDF. Vraci radek fronty (`QUEUED`), ne hotovy soubor. */
export async function requestPdfExport(ddCaseId: string, kind: ReportExportKind): Promise<DdExport> {
  return unwrap(
    apiClient.POST('/v1/duediligence/cases/{id}/export/{kind}.pdf', {
      params: { path: { id: ddCaseId, kind } },
    }),
  );
}
